import { createSelector } from "reselect"
import { get, findIndex, isEmpty } from "lodash"
import { OK } from "helpers/data-statuses"

export const STEPS = (editing, isPortfolio) => [{
  id: "setup",
  label: `Setup smart ${isPortfolio ? "portfolio" : "trade"}`,
  cancelButton: {
    text: "Cancel",
  },
  submitButton: {
    isDisabled: ({ tradeDate, tradeSize, basketSize, instrumentType, isDateUnavailable, basketSizeErrors }) => isDateUnavailable || !tradeDate || !tradeSize || !basketSize || (instrumentType === "SECURITY" && !tradeSize) || basketSizeErrors,
    text: "Next",
  },
}, {
  id: "universe",
  label: "Select universe",
  cancelButton: {
    text: "Cancel",
  },
  submitButton: {
    isDisabled: ({ filter, securitiesCount }) => !filter || !securitiesCount || securitiesCount === 0,
    text: "Next",
  },
}, {
  id: "finalize",
  label: "Finalize experiment",
  cancelButton: {
    text: "Cancel",
  },
  submitButton: {
    isDisabled: ({ status }) => status !== OK,
    text: editing ? "Update And Close" : "Save Experiment",
    trackingId: editing ? "update" : "save",
  },
}]

const getStep = props => get(props, "params.step")
const getExperimentId = (props) => get(props, "params.experimentId")
const getIsPortfolio = props => !isEmpty(get(props, "instrumentPortfolio"))

export const getActiveStep = state => get(state, "modules.smartTrade.activeStep")
export const getCompletedStep = state => get(state, "modules.smartTrade.completedStep")
export const getSteps = createSelector(
  [getExperimentId, getIsPortfolio],
  (experimentId, isPortfolio) => STEPS(!!experimentId, isPortfolio),
)

export const getUrlStep = createSelector(
  [getStep, getExperimentId],
  (step, experimentId) => findIndex(STEPS(!!experimentId), { id: step }),
)
